import {useEffect, useState} from 'react';
import {MAX_BASE_VIEWER_WIDTH_PX} from '../constant/talkViewerConstant';

/**
 * 스크롤바가 영역을 처리해줘야 하는 경우가 있기 때문에, 여기서 스크롤 바 width도 함께 반환해준다
 * return [viewerWidth, scrollbarWidth]
 * 대부분 tvs unit으로 처리되지만, 일부 직접 계산해야 하는 경우가 있어 hook도 추가했습니다
 */
export function useViewerWidth() {
  const [viewerWidth, setViewerWidth] = useState(0);
  const [scrollbarWidth, setScrollbarWidth] = useState(0);

  useEffect(() => {
    const windowResizeListener = () => {
      const {clientWidth} = document.documentElement;
      let width = clientWidth;
      if (clientWidth > MAX_BASE_VIEWER_WIDTH_PX) {
        width = MAX_BASE_VIEWER_WIDTH_PX;
      } else {
        setScrollbarWidth(window.innerWidth - clientWidth);
      }
      setViewerWidth(width);
    };
    windowResizeListener();
    window.addEventListener('resize', windowResizeListener);
    return () => {
      window.removeEventListener('resize', windowResizeListener);
    };
  }, []);
  return {viewerWidth, scrollbarWidth};
}
